import { render, staticRenderFns } from "./date-range.vue?vue&type=template&id=2652849a&"
import script from "./date-range.vue?vue&type=script&lang=js&"
export * from "./date-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2652849a')) {
      api.createRecord('2652849a', component.options)
    } else {
      api.reload('2652849a', component.options)
    }
    module.hot.accept("./date-range.vue?vue&type=template&id=2652849a&", function () {
      api.rerender('2652849a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/date-picker/src/panel/date-range.vue"
export default component.exports